module.exports = __webpack_public_path__ + "img/Bank Index.6b92d365.png";